import { LoadingCommon, TableList } from '@components';
import { images } from '@constants';
import { ArrowLeftIcon } from '@constants/svgs';
import { useCallback, useMemo, useRef } from 'react';
import { QuantityEditDialog } from './components/QuantityEditDialog';
import { SendConfirmDialog } from './components/SendConfirmDialog';
import { getColumns } from './columns';
import {
  HEIGHT_TABLE_SCROLL,
  MANAGEMENT_SEAL_REQUEST_CONSTANT,
} from './constant';
import useManagementSealRequest from './hooks/useManagementSealRequest';
import { ManagementSealRequestWrapper } from './ManagementSealRequestStyled';

const { TITLE, MESSAGE, LABEL } = MANAGEMENT_SEAL_REQUEST_CONSTANT;

function ManagementSealRequest() {
  const tableRef = useRef(null);
  const { state, handler } = useManagementSealRequest();
  const {
    rows,
    loadingPage,
    selectedRow,
    quantityEditOpen,
    sendConfirmOpen,
    newQuantity,
    quantityError,
    loadingConfirm,
  } = state;

  const handleScroll = useCallback(() => {
    return;
  }, []);

  const columns = useMemo(() => {
    return getColumns({
      handleOpenQuantityEdit: handler.handleOpenQuantityEdit,
    });
  }, [handler.handleOpenQuantityEdit]);

  return (
    <LoadingCommon loading={loadingPage}>
      <ManagementSealRequestWrapper listdata={rows.length}>
        <div className="management-seal-request_header">
          <div className="management-seal-request_header-title">
            <button onClick={handler.handleNavigateBack}>
              <ArrowLeftIcon />
            </button>
            <h1>{TITLE.MANAGEMENT_SEAL_REQUEST}</h1>
          </div>
        </div>

        <TableList
          tableRef={tableRef}
          image={images.noResult}
          columns={columns}
          handleScroll={handleScroll}
          heightTableScroll={HEIGHT_TABLE_SCROLL}
          listData={rows}
          messageNoData={MESSAGE.NO_DATA}
          rowKey={null}
          borderColor="var(--color-border-primary)"
        />

        <p className="management-seal-request_total">
          {LABEL.TOTAL_RECORDS_PREFIX}
          <span>{rows.length}</span>
          {LABEL.TOTAL_RECORDS_SUFFIX}
        </p>

        {/* VAMS_PC_008_01 数量編集ダイアログ */}
        <QuantityEditDialog
          open={quantityEditOpen}
          row={selectedRow}
          newQuantity={newQuantity}
          quantityError={quantityError}
          onChangeQuantity={handler.handleChangeQuantity}
          onCancel={handler.handleCloseQuantityEdit}
          onSubmit={handler.handleSubmitQuantity}
        />

        {/* VAMS_PC_008_02 送信確認ダイアログ — nested on top of Dialog D */}
        <SendConfirmDialog
          open={sendConfirmOpen}
          loading={loadingConfirm}
          row={selectedRow}
          newQuantity={newQuantity}
          onCancel={handler.handleCloseSendConfirm}
          onOk={handler.handleConfirmSend}
        />
      </ManagementSealRequestWrapper>
    </LoadingCommon>
  );
}

export { ManagementSealRequest };
